import { alertConfirm } from '../../../alertDispatcher';

/**
 * Alert user of barcode issue before downloading
 * @param {string} constructorName Name of the constructor
 */
export async function alertConfirmDownload(constructorName: string) {
  return alertConfirm('There is barcode issues. Continue downloading?', constructorName);
}
